/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/components/modular-form/custom/SubsectionHeader.tsx
 * Release: v2.0.0
 * Descrizione: Header di sottosezione per form preventivi
 */

import React from 'react';
import type { CustomComponentProps } from '../types';

export const SubsectionHeader: React.FC<CustomComponentProps> = ({
  field
}) => {
  return (
    <div className="mb-4">
      <h4 className="text-lg font-semibold text-blue-400 border-b border-slate-600 pb-2">
        {field.label}
      </h4>
    </div>
  );
};